import styled from "styled-components";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
export const Wrapper = styled.div`
  position: relative;
`;
export const NotificationButton = styled.button<{ accountLevel: LEVEL_TYPE }>`
  position: relative;
  ${FLEX.FlexCenterCenter};
  height: 50px;
  color: ${({ accountLevel, theme }) =>
    accountLevel === LEVEL_TYPE.EU && theme.value === "light"
      ? COLORS.BORDER
      : COLORS.WHITE};
  svg {
    width: 27px;
    height: 27px;
  }
  span {
    position: absolute;
    bottom: 50%;
    right: 50%;
    font-size: ${calcRem(9.6)};
    color: ${COLORS.WHITE};
    background-color: ${COLORS.ORANGE};
    border-radius: 8px;
    margin-right: 0;
    width: 16px;
    height: 16px;
    margin-bottom: -2px;
    font-weight: 700;
    ${FLEX.FlexCenterCenter};
  }
`;
export const IconNotification = styled.div<{ open: boolean }>`
  opacity: ${({ open }) => (open ? 1 : 0.5)};
`;
export const NotificationList = styled.div`
  border-bottom: 1px solid
    ${({ theme }) =>
      theme.value === "dark" ? COLORS.BORDER : LIGHT_THEME_COLORS.BORDER};
`;
export const NotificationButtonWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 1px;
`;
export const NotificationPopupWrapper = styled.div`
  position: absolute;
  top: 100%;
  right: -10px;
  background-color: ${({ theme }) =>
    theme.value === "dark" ? COLORS.PRIMARY2 : COLORS.WHITE};
  color: ${({ theme }) =>
    theme.value === "dark" ? COLORS.WHITE : COLORS.BLACK};
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border: 2px solid
    ${({ theme }) =>
      theme.value === "dark" ? COLORS.BORDER : LIGHT_THEME_COLORS.BORDER};
  width: 446px;
  max-width: calc(100vw - 20px);
  margin-top: 10px;
  padding: 0 15px 15px;
  ${mediaQuery.isMobile} {
    position: fixed;
    top: 50px;
    width: 100%;
    max-width: none;
    border-radius: 0;
    border: none;
    box-shadow: none;
    right: 0;
    padding: 0;
    margin: 0;
    .infinite-list-component {
      max-height: calc(100dvh - 105px);
    }
  }
`;
export const NotificationTitle = styled.div`
  ${FLEX.FlexBetweenCenter};
  padding: 15px 0;
  border-bottom: 1px solid
    ${({ theme }) =>
      theme.value === "dark" ? COLORS.BORDER : LIGHT_THEME_COLORS.BORDER};
  gap: 10px;
  position: relative;
  h3 {
    font-size: ${calcRem(18)};
    font-weight: 600;
  }
  label {
    font-size: ${calcRem(14)};
  }
  ${mediaQuery.isMobile} {
    padding: 15px 10px;
  }
`;
export const NotificationSettingWrapper = styled.div`
  position: absolute;
  top: 100%;
  margin-top: -7px;
  min-width: 150px;
  z-index: 1;
  right: 6px;
  background-color: ${COLORS.WHITE};
  border: 1px solid #abbbd3;
  border-radius: 3px;
  padding: 8px 0;
  button {
    font-size: ${calcRem(12)};
    color: ${COLORS.BLACK};
    vertical-align: middle;
    padding: 4px 11px;
    ${FLEX.FlexCenterCenter};
    gap: 5px;
    img {
      margin-top: -3px;
    }
  }
`;
export const NotificationSettingButton = styled.button`
  ${FLEX.FlexCenterCenter};
  gap: 3px;
  flex-direction: column;
  padding: 0 10px;
  span,
  &:before,
  &:after {
    content: "";
    display: block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${({ theme }) =>
      theme.value === "dark" ? COLORS.WHITE : COLORS.BLACK};
  }
  &:before,
  &:after {
    content: "";
  }
`;
export const NotificationReadButton = styled.button`
  position: absolute;
  right: 0px;
  top: 9px;
  color: ${({ theme }) => (theme.value === "dark" ? "#C9CCD5" : "#7883A1")};
  padding: 10px 0;
  svg {
    display: block;
    width: 17px;
  }
  ${mediaQuery.isMobile} {
    top: 0;
  }
`;
export const NotificationSortButton = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 8px;
`;
export const NotificationItem = styled.li<{ isRead: boolean; noLink: boolean }>`
  position: relative;
  padding: 18px 11px;
  border-bottom: 1px solid
    ${({ theme }) =>
      theme.value === "dark" ? COLORS.BORDER : LIGHT_THEME_COLORS.BORDER};
  gap: 9px;
  display: grid;
  grid-template-columns: 51px auto;
  color: ${({ isRead, theme }) =>
    isRead ? "#7883a1" : theme.value === "dark" ? COLORS.WHITE : COLORS.BLACK};
  ${({ noLink }) =>
    !noLink &&
    `
    h3, p {
      cursor: pointer;
    }
  `}
  b {
    font-weight: 600;
  }
  > span {
    width: 51px;
    height: 51px;
    border-radius: 3px;
    ${FLEX.FlexCenterCenter};
    background-color: ${({ theme }) =>
      theme.value === "dark" ? COLORS.PRIMARY3 : "#C9CCD5"};
    color: ${({ theme }) =>
      theme.value === "dark" ? COLORS.WHITE : COLORS.BLACK};
    position: relative;
    ${({ isRead, theme }) =>
      !isRead &&
      `
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 17px;
        height: 17px;
        border-radius: 50%;
        background-color: ${COLORS.ORANGE};
        border: 2px solid ${
          theme.value === "dark" ? COLORS.PRIMARY2 : COLORS.WHITE
        };
        transform: translate(-50%, -50%);
      }
    `}
    ${mediaQuery.isMobile} {
      width: 40px;
      height: 40px;
      svg {
        width: 24px;
        height: 24px;
      }
      ${({ isRead }) =>
        !isRead &&
        `
      &:before {
        width: 13px;
        height: 13px;
      }
    `}
    }
  }
  > div {
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 6px;
    padding-top: 3px;
    ${mediaQuery.isMobile} {
      width: 100%;
      gap: 4px;
      padding-top: 1px;
    }
    ${({ noLink }) =>
      !noLink &&
      `
      &:hover p,
      &:hover h3 b {
        text-decoration: underline;
      }
    `}
  }
  h3 {
    font-size: ${calcRem(14)};
    font-weight: 600;
    column-gap: 15px;
    row-gap: 3px;
    width: 100%;
    padding-right: 15px;
    ${FLEX.FlexStartEnd};
    flex-wrap: wrap;
    small {
      font-size: ${calcRem(10)};
      font-weight: 400;
      color: #7883a1;
    }
  }
  p {
    font-size: ${calcRem(12)};
    line-height: 1.25;
  }
  &:last-child {
    border-bottom: none;
  }
  ${mediaQuery.isMobile} {
    padding: 10px 10px;
    grid-template-columns: 40px auto;
  }
`;
